import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import DrawerComponent from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Drawer';

const styles = (theme) => ({
  root: {},
  content: {},
  contentHidden: {
    display: 'none',
  },
  drawerPaper: {
    borderTopLeftRadius: theme.radius.md,
    borderTopRightRadius: theme.radius.md,
  },
});

const Drawer = ({
  className,
  classes,
  children,
  open,
  onClose,
}) => {
  return (
    <DrawerComponent
      className={classNames(classes.root, className)}
      anchor={'bottom'}
      open={open}
      variant={'temporary'}
      onClose={onClose}
      disableEnforceFocus
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      {children}
    </DrawerComponent>
  );
};

Drawer.defaultProps = {
  className: '',
};

Drawer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles)(Drawer);
